module.exports = __webpack_public_path__ + "instagram-reels-shadow.095e5b41ad0a41ec02e9c5c006e026cb.svg";